<template>
  <div id="app">
    <!-- <router-link to="/privacyagreemen">用户隐私服务</router-link> -->
    <keep-alive >
      <router-view  v-if="$route.meta.keepAlive" :style="styleHeight"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :style="styleHeight"/>
    <!-- <router-view :style="styleHeight" /> -->
    <!-- <cube-loading class="loading-dom" :size="40" v-show="loadIngFlg"></cube-loading> -->
  </div>
</template>
<script>
import { getQueryString } from '@/utils';
import store from '@/store/'
let utm_source = getQueryString('utm_source');
const fetchEventData = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      console.log(`HTTP error! status: ${response.status}`);
    }
    return await response.json();
  } catch (error) {
    console.log('Error fetching data: ', error);
    return [];
  }
}

export default {
  data() {
    return {
      styleHeight: '',
    };
  },

  // updated() {
  //
  // },

  created() {
    console.log(this.$route)
    if (utm_source) {
      sessionStorage.setItem('fly_utm_source', utm_source);
    }
    window.addEventListener('beforeunload', () => {
      sessionStorage.setItem('flytoken', window.tokenFromNative);
      if (utm_source) {
        sessionStorage.setItem('fly_utm_source', utm_source);
      }
    });
    if (sessionStorage.getItem('flytoken') && sessionStorage.getItem('flytoken') != 'undefined') {
      window.tokenFromNative = sessionStorage.getItem('flytoken');
    }
  },
  // computed: {
  //   loadIngFlg() {
  //     return this.$store.state.app.loading;
  //   }
  // },
  mounted(){
    // if(!this.initView()){
    //   console.log(document.body.scrollHeight)
    //   this.styleHeight = `height:${document.body.scrollHeight}px`;
    // }
    // window.scroll(0, 0);
    this.init()
  },
  methods: {
    // 排除页面预渲染挂载内联样式。
    initView() {
      let views = [
        '/activity/luckyBox',
        '/activity/myReward',
        '/activity/activityCount',
        '/activity/luckyBoxRecords',
      ];
      let path = this.$route.path;
      return views.indexOf(path) > -1 ? true : false;
    },
    init(){
      store.dispatch('app/checkIsDark')       
    }
  },
};
</script>
<style lang="less">
@import './style/reset.css';
@import './style/common.css';
</style>

<style scoped>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  font-size: 0.373333rem;
  height: 100%;
  min-height: 100vh;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}
/* .loading-dom{
  position: fixed !important;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 999;
} */
#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
